import config from "../../app.json";
import axios from "axios";
import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { Context } from "../../Reducers/Store";
import AlertComponent from "../AlertComponent";
import { Row, Col, Button } from "react-bootstrap";
import FieldSelect from "../Fields/FieldSelect";
import ChimpLogin from "../../Assets/Svgs/dark-logo.svg";
import Image from "../Image/image";

import "./industryandteammembers.scss";

function IndustryAndTeamMembers(props) {
  const [state, dispatch] = useContext(Context);

  const [industryTypes, setIndustryYypes] = useState([]);
  const [teamSizes, setTeamSizes] = useState([]);

  const [selectedIndustryType, setSelectedIndustryType] = useState(null);
  const [selectedTeamSize, setSelectedTeamSize] = useState(null);
  const [saveIsAvailable, setSaveIsAvailable] = useState(false);
  const [allowSave, setAllowSave] = useState(false);

  let navigate = useNavigate();

  const callApi = async (endPoint, setFunction, functionName) => {
    await axios
      .get(config.API_HM + "/" + endPoint)
      .then((result) => {
        const data = result.data;

        const finalResult = data.map((item) => {
          return {
            value: item.id,
            label: item.description,
          };
        });

        setFunction(finalResult);
      })
      .catch((error) => {
        AlertComponent("Error", error.message ?? "Something went wrong. " + functionName + " could not be loaded.", { icon: `error` });
      });
  };

  const checkUserInfo = async () => {
    await axios.get(config.API_HM + "/profile/additionalinfo").then((result) => {
      const data = result.data;
      if (data.industry) {
        setSelectedIndustryType({
          value: data.industry.id,
          label: data.industry.description,
        });
      }
      if (data.teamSize) {
        setSelectedTeamSize({
          value: data.teamSize.id,
          label: data.teamSize.description,
        });
      }
    }).catch((error) => {
      AlertComponent("Error", error.message ?? "Something went wrong. " + functionName + " could not be loaded.", { icon: `error` });
    });
  };

  const getUserInfo = async () => {
    await checkUserInfo();
  };

  useEffect(() => {
    callApi(`users/industrytypes`, setIndustryYypes, `Industry Type`);
    callApi(`users/teamsizes`, setTeamSizes, `Team Size`);
  }, [0]);

  useEffect(() => {
    if (industryTypes?.length && teamSizes?.length) {
      getUserInfo();
    }
  }, [industryTypes, teamSizes]);

  useEffect(() => {
    setSaveIsAvailable(selectedIndustryType != null && selectedTeamSize != null);
  }, [selectedIndustryType, selectedTeamSize]);

  useEffect(() => {
    if (allowSave) {
      const payload = {
        industryId: selectedIndustryType.value,
        teamSizeId: selectedTeamSize.value,
      };

      axios
        .post(config.API_HM + "/profile/additionalinfo", payload)
        .then((result) => {
          if (onSave) {
            onSave(result);
          }
          setAllowSave(false);
        })
        .catch((error) => {
          AlertComponent("Error", error.message ?? "Something went wrong. " + functionName + " could not be loaded.", { icon: `error` });
        });
    }
  }, [allowSave]);

  const { title, key, onSave, showSigningUpMessage, firstScreen, buttonTitle = `Continue`, containerClassName = ``, className = `` } = props;

  const handleSave = () => {
    if (!selectedIndustryType) {
      AlertComponent("Error", "Industry Type is required. ", { icon: `error` });
      return;
    }

    if (!selectedTeamSize) {
      AlertComponent("Error", "Team Size is required. ", { icon: `error` });
      return;
    }

    setAllowSave(true);
  };

  const handleSkip = () => {
    navigate("/selectplan", { replace: false });
  };

  const customStylesColors = {
    control: (base) => ({
      ...base,
      border: "none",
      boxShadow: "none",
      borderRadius: "20px",
      innerWidth: "100%",
      outerWidth: "100%",
      width: "100%",
      backgroundColor: "transparent",
    }),
    indicatorSeparator: (base) => ({
      ...base,
      display: "none",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#6C7275",
      width: "400px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "24px",
      letterSpacing: "-0.01em",
      textAlign: "left",
    }),
  };

  const saveButtonClass = saveIsAvailable ? `` : `disabled`;
  const signingUpMessage = showSigningUpMessage ? `You're signing up as ` + state?.profile?.email : ``;
  const centeredClass = firstScreen ? `centered-industry-items` : ``;
  return (
    <div className={`industry-container ${containerClassName}`} key={key}>
      {firstScreen && (
        <div className={`logo-subscription`} style={{ display: "flex", justifyContent: "center" }}>
          <Row>
            <Col className="col-md-12">
              <Image src={ChimpLogin} width={200} height={50} />
            </Col>
          </Row>
        </div>
      )}
      <div className="title-container">
      {firstScreen && <h5 className={`title ${centeredClass} ${className}`} style={{textAlign: "left"}}>{title}</h5>}
      {!firstScreen && <h2>{title}</h2>}
      <small className={`${centeredClass}`}>{signingUpMessage}</small>
      </div>
     
     

      <div className={`${centeredClass}`}>
        <div className={`industry-select-items ${centeredClass}`}>
          <div className="form-group ">
            <div className="input-container select-container">
              <FieldSelect
                customStyles={customStylesColors}
                inputClassName="industry-select-items-inner"
                options={industryTypes}
                id={`selectedIndustryType`}
                name={`selectedIndustryType`}
                onChange={setSelectedIndustryType}
                value={selectedIndustryType}
                placeholder={`Industry Type`}
              />
            </div>
          </div>
        </div>
      </div>

      <div className={`${centeredClass}`}>
        <div className={`industry-select-items ${centeredClass}`}>
          <div className="form-group ">
            <div className="input-container select-container">
              <FieldSelect
                customStyles={customStylesColors}
                inputClassName="industry-select-items-inner team-size-select"
                options={teamSizes}
                id={`selectedTeamSize`}
                name={`selectedTeamSize`}
                onChange={setSelectedTeamSize}
                value={selectedTeamSize}
                placeholder={`Number of team members`}
              />
            </div>
          </div>
        </div>
      </div>

      <div className={`${centeredClass}`}>
        <div className="btn-save-industry">
          <Button variant="outline-primary" onClick={handleSave} className={`${saveButtonClass}`}>
            {buttonTitle}
          </Button>
        </div>
      </div>
      {firstScreen && (
        <div className={`${centeredClass}`}>
          <div className="btn-skip-industry">
            <span onClick={handleSkip} style={{ width: "100%", marginTop: "10px", marginBottom: "10px" }}>
              Skip
            </span>
          </div>
        </div>
      )}
    </div>
  );
}

export default IndustryAndTeamMembers;
